import React from "react";
import editIcon from "../../../../../../assets/edit.svg";
import trashIcon from "../../../../../../assets/trash.svg";

const TriggerCard = ({ trigger, onEdit, onDeactivate, onDelete }) => {
  return (
    <div className="trigger-card">
      <div className="trigger-card-header">
        <div className="trigger-card-title">
          <span className="trigger-name">{trigger.name}</span>
          <span className={`trigger-status ${trigger.status.toLowerCase()}`}>
            {trigger.status}
          </span>
        </div>
      </div>
      <div className="trigger-card-content">
        <p className="trigger-description">{trigger.description}</p>
      </div>
      <div className="trigger-card-footer">
        <div className="trigger-meta">
          <span className="trigger-created">Created: {trigger.createdDate}</span>
          <span className="trigger-separator">|</span>
          <span className="trigger-creator">
            Created By: {trigger.createdBy}
          </span>
        </div>
        <div className="trigger-actions">
          <img
            src={editIcon}
            alt="Edit"
            className="trigger-action-icon edit-icon"
          />
          <button className="trigger-action-link" onClick={() => onEdit(trigger.id)}>
            Edit
          </button>
          <svg
            className="trigger-action-icon close-icon"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 2L10 10M10 2L2 10"
              stroke="#6A8991"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <button
            className="trigger-action-link"
            onClick={() => onDeactivate(trigger.id)}
          >
            {trigger.status === "Active" ? "Deactivate" : "Activate"}
          </button>
          <img
            src={trashIcon}
            alt="Delete"
            className="trigger-action-icon delete-icon"
          />
          <button className="trigger-action-link" onClick={() => onDelete(trigger.id)}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default TriggerCard;
